import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import moment from 'moment';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest, parsePrinterXML } from '../../helpers';
import { DymoPrint } from '../../lib/labels/DYMO.print';
import Dymo from '../../lib/labels/dymojs';
import Boca from '../../lib/labels/boca';
import Star from '../../lib/labels/star';
import AlertModal from '../Common/AlertModal/AlertModal';
import AlertModalBoca from '../Common/AlertModalBoca/AlertModalBoca';
import AlertModalStar from '../Common/AlertModalStar/AlertModalStar';
import PrinterOptions from '../Common/PrinterOptions/PrinterOptions';
import CouponForm from './CouponForm/CouponForm';
import CouponEvents from './CouponEvents/CouponEvents';
import CouponReview from './CouponReview/CouponReview';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);
class CreateCoupon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSecondStepOpen: false,
            couponDetails: {
                id: null,
                couponType: "single",
                couponName: "",
                couponValue: "",
                couponValueType: "dollars",
                couponCode: "",
                nbRedemptionSingle: "0",
                nbRedemptionMultiple: "0",
                couponStartDate: moment(new Date()),
                couponStartTime: "00:00",
                couponEndDate: moment().endOf('year'),
                couponEndTime: "00:00",
                couponDescription: ""
            },
            activeCoupon: {},
            couponExists: false,
            isReadyToSubmit: false,
            isReadyToSelectEvents: false,
            isReadyToSelectCodes: false,
            events: [],
            selectedEvents: [],
            couponCodes: [],
            selectedCodes: [],
            validation: {
                single: {
                    couponName: {
                        valid: null,
                        msg: ''
                    },
                    couponCode: {
                        valid: null,
                        msg: ''
                    },
                    nbRedemptionSingle: {
                        valid: null,
                        msg: ''
                    }
                },
                multiple: {
                    couponName: {
                        valid: null,
                        msg: ''
                    },
                    nbRedemptionMultiple: {
                        valid: null,
                        msg: ''
                    }
                }
            },
            message: {
                title: '',
                content: '',
                type: ''
            },
            printers: [],
            printersBoca: [],
            currentPrinterBoca: '',
            printersStar: [],
            printersStarUSB: [],
            currentPrinterStar: '',
            isModalOpen: false,
            isModalOpenBoca: false,
            isModalOpenStar: false,
            client: {
                id: null,
                daily_email: false,
                client_name: '',
                client_email: '',
                client_phone: '',
                billing_contact: '',
                billing_address_1: '',
                billing_address_2: '',
                billing_city: '',
                billing_country: 'US',
                billing_state: 'AL',
                billing_zip: '',
                referred_by: '',
                donation: false,
                donation_text: '',
                donation_email: '',
                collect_cust_info: false,
                allow_will_call: false,
                allow_callcenter_refund: false,
                allow_callcenter_exchange: false,
                url_short_name: '',
                payout_option: 'check-at-close',
                payout_frequency: 'daily',
            },
        }
    }

    componentWillReceiveProps(props) {
        if(props.saveCouponMode){
            // Clear Save Coupon mode to avoid duplicate call
            this.props.saveUpdateCouponEvent(false);
            // Save the coupon
            this.saveCoupon();
        }
    }

    componentDidMount() {
        this.checkIfCouponExists();
        this.validateAllRequiredFields();
        this.getEventsList();
        this.getClient();
        setTimeout(() => {
            this.detectDymoPrinter();
            this.detectBocaPrinter();
            this.detectStarPrinter();
        }, 2000);
    }

    componentWillUnmount() {
        this.props.toggleSaveCouponButton(false);
        this.props.enableSaveCouponButton(false);
        this.props.toggleCouponExists(false);
    }

    componentDidUpdate() {
        let hash = this.props.routeProps.history.location.hash.replace('#', '');
        if (hash) {
            let node = ReactDOM.findDOMNode(this.refs[hash]);
            if (node) {
                node.scrollIntoView();
            }
        }
    }

    getClient  = async () => {
        (async () => {
            try {
                const response = await getCurrentClient();
                console.log('Current Client Response: ', response);
                this.setState({ client: response.data.client || {} });
            } catch (error) {
                console.log(error);
            }
        })()

        async function getCurrentClient() {
            return await ApiRequest('/clients/current');
        }
    }

    setCouponType = (type) => {
        let couponDetails = {...this.state.couponDetails}
        couponDetails.couponType = type;

        this.setState({ couponDetails });
        this.setState({ isSecondStepOpen:true });

        this.props.toggleSaveCouponButton(true);

        this.validateAllRequiredFields();
    }

    handleChange = (e, fieldName) => {
        let value;
        let name;
        
        // is a date field
        if(fieldName === "couponStartDate" || fieldName === "couponEndDate") {
            value = e;
            name = fieldName;
        } else {
            value = e.target.value
            name = e.target.name;
        }

        const couponDetails = {...this.state.couponDetails};
        const key = couponDetails.couponType;

        couponDetails[name] = value;
        this.setState({ couponDetails });

        if (e && e.target && e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.validation.value;
            this.validate(value, key, name, validationRegEx);
        }

        this.validateRequiredField(e, fieldName);
    }

    validate = (value, key, name, validationRegEx) => {
        const validation = { ...this.state.validation };
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value) && value !== '') {
            validation[key][name]['msg'] = strings.errorInvalid;
            isValid = false;
        }
        validation[key][name]['valid'] = isValid;
        this.setState({ validation });
    }
    
    validateRequiredField = (e, fieldName) => {
        // no validation required for datepickers
        if(fieldName !== "couponStartDate" && fieldName !== "couponEndDate") {
            const name = e.target.name;
            const validation = { ...this.state.validation };
            const couponDetails = {...this.state.couponDetails}
            const key = couponDetails.couponType;

            // required
            if (e.target.value === '' && e.target.hasAttribute('required')) {
                // update both single/multiple objects
                if (name === 'couponName') {
                    validation['single'][name]['msg'] = strings.errorRequired;
                    validation['single'][name]['valid'] = false;
                    validation['multiple'][name]['msg'] = strings.errorRequired;
                    validation['multiple'][name]['valid'] = false;
                } else {
                    validation[key][name]['msg'] = strings.errorRequired;
                    validation[key][name]['valid'] = false;
                }
                this.setState({ validation });
            } else if(typeof(validation[key][name]) !== 'undefined') {
                if (name === 'couponName') {
                    validation['single'][name]['valid'] = true;
                    validation['multiple'][name]['valid'] = true;
                } else {
                    validation[key][name]['valid'] = true;
                }
            }

            // has regex validation
            if (e.target.attributes.getNamedItem('validation')) {
                const validationRegEx = e.target.attributes.validation.value;
                this.validate(e.target.value, key, name, validationRegEx);
            }

            this.setState({ validation });
        }

        this.validateAllRequiredFields();
    }

    validateAllRequiredFields = () => {
        let validation = { ...this.state.validation };
        const couponDetails = {...this.state.couponDetails}
        const key = couponDetails.couponType;
        validation = validation[key]
        let isReadyToSubmit = { ...this.state.isReadyToSubmit };
        let i = Object.keys(validation).length;
        for (let field in validation) {
            if (validation[field]['valid'] === true) {
                i--;
            }
        }
        isReadyToSubmit = (i === 0);
        this.setState({ isReadyToSubmit });
        this.props.enableSaveCouponButton(isReadyToSubmit);
    }

    formatDate = (date, time) => {
        const userTimeZone = moment.tz.guess();
        const inverseOffset = moment().tz(userTimeZone).format().substring(20,22) * 60;
        date = moment(date).tz(userTimeZone).format();
        let hours = parseInt(time.substring(0, 2), 10);
        let minutes = parseInt(time.substring(3, 5), 10);
        return moment(date).hour(hours).minutes(minutes).add(inverseOffset, 'minutes').format();
    }

    saveCoupon = () => {
        this.setMessage('','','loading');

        // get infos
        let couponDetails = {...this.state.couponDetails}
        let couponNbRedemption = (couponDetails.couponType === 'single') ? couponDetails.nbRedemptionSingle : couponDetails.nbRedemptionMultiple;
        let couponStartDate = this.formatDate(couponDetails.couponStartDate, couponDetails.couponStartTime);
        let couponEndDate = this.formatDate(couponDetails.couponEndDate, couponDetails.couponEndTime);
        let couponValue = (couponDetails.couponValueType === 'percent') ? couponDetails.couponValue/100 : couponDetails.couponValue;
        let couponCount = (couponDetails.couponType === 'single') ? 1 : couponDetails.nbRedemptionMultiple;
        // construct object to send
        const coupon = {
            name: couponDetails.couponName,
            type: couponDetails.couponValueType,
            amount: parseFloat(couponValue),
            start: couponStartDate,
            expires: couponEndDate,
            coupon_count: parseInt(couponCount, 10),
            desc: couponDetails.couponDescription,
            event_date_ids: this.state.selectedEvents,
            allowed_uses: parseInt(couponNbRedemption, 10)
        };
        if(couponDetails.couponType === 'single') {
            coupon["code"] = couponDetails.couponCode;
        }

        const requestUrl = (this.state.couponExists) ? '/coupons/' + this.state.activeCoupon.id : '/coupons';
        const requestMethod = (this.state.couponExists) ? 'PUT' : 'POST';

        (async () => {
            try {
                const createCouponResponse = await createCoupon(coupon);
                console.log('create coupon response: ', createCouponResponse);

                if((!this.state.couponExists && createCouponResponse.data.coupon) || (this.state.couponExists && createCouponResponse.data.success === true) ){
                    this.setMessage(window.general_strings.msg.yay, strings.msg.saved, 'success');

                    if(typeof createCouponResponse.data.coupon !== 'undefined'){
                        this.props.routeProps.history.push('/create-coupon/' + createCouponResponse.data.coupon.id);
                        this.setState({couponExists: true});
                        this.props.toggleCouponExists(true);
                        this.getActiveCouponInfo(createCouponResponse.data.coupon.id);
                    }
                } else {
                    if (createCouponResponse.data.error.details) {
                        this.setMessage(window.general_strings.msg.oops, createCouponResponse.data.error.details[0].field + ' - ' + createCouponResponse.data.error.details[0].message,'error');
                    } else {
                        this.setMessage(window.general_strings.msg.oops, createCouponResponse.data.error.code,'error');
                    }
                }
            } catch (error) {
                console.log(error);
            }
            window.scrollTo(0, 0);
        })()

        async function createCoupon(coupon) {
            return await ApiRequest(requestUrl, {
                method: requestMethod,
                data: coupon
            });
        }
    }

    getEventsList = () => {
        (async () => {
            try {
                const eventsListResponse = await eventsList();
                console.log('events list response: ', eventsListResponse);

                if(eventsListResponse.data.event_dates){
                    this.setMessage('','','');
                    
                    let events = eventsListResponse.data.event_dates.map(e => {
                        return {
                            id: e.event_date_id,
                            name: e.event_name,
                            date: moment(e.event_datetime_local.substring(0, 19)),
                        }
                    });

                    this.setState({ 
                        events,
                        isReadyToSelectEvents: true
                    });
                } else {
                    this.setMessage(window.general_strings.msg.oops, eventsListResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function eventsList() {
            return await ApiRequest('/event-dates', {
                method: 'GET'
            });
        }
    }

    selectAllEventCheckboxes = (e) => {
        let value = e.target.value;
        (e.target.checked) ? value = true : value = false;
        const table = document.getElementById('couponEventsTbl');
        const inputs = table.querySelectorAll('input');
        inputs.forEach((input) => {
            input.checked = value;
        });

        this.updateSelectedEvents();
    }

    updateSelectedEvents = () => {
        const table = document.getElementById('couponEventsTbl');
        const inputs = table.querySelectorAll('input');
        let selectedEvents = [];

        inputs.forEach((input) => {
            if(input.checked && input.id != "input-event-all") {
                selectedEvents.push(parseInt(input.id.replace("input-event-", ""), 10));
            }
        });
        
        let isReadyToSelectEvents = selectedEvents.length > 0;
        this.setState({ 
            selectedEvents,
            isReadyToSelectEvents
        });
    }

    checkIfCouponExists = () => {
        // If coupon ID has been passed
        const params = this.props.routeProps.match.params;
        if(params && params.id) {
            this.setState({ 
                couponExists: true,
                isSecondStepOpen: true
            });

            this.props.toggleCouponExists(true);

            // populate activeCoupon object
            this.getActiveCouponInfo(params.id);

            // show save button
            this.props.toggleSaveCouponButton(true);
        }
    }

    getActiveCouponInfo = (couponId) => {
        (async () => {
            try {
                const activeCouponInfoResponse = await activeCouponInfo();
                console.log('active coupon info response: ', activeCouponInfoResponse);

                if(activeCouponInfoResponse.data.coupon){
                    let response = activeCouponInfoResponse.data.coupon;
                    this.setMessage('','','');

                    // set all required fields to valid
                    let validation = {...this.state.validation};
                    for (let type in validation) {
                        for (let field in validation[type]) {
                            validation[type][field]['valid'] = true;
                        }
                    }

                    let couponType = (response.codes.length === 1) ? "single" : "multiple";
                    let amount = (response.type === "percent") ? response.amount * 100 : response.amount;
                    var offset = moment().utcOffset();
                    let startDate = moment(response.start).utcOffset(offset).toString();
                    let startTime = moment(response.start).utcOffset(offset).toString().substring(16,21);
                    let expiresDate = moment(response.expires).utcOffset(offset).toString();
                    let expiresTime = moment(response.expires).utcOffset(offset).toString().substring(16,21);

                    let activeCoupon = {
                        id: response.id,
                        couponType: couponType,
                        couponName: response.name,
                        couponValue: String(amount),
                        couponValueType: response.type,
                        couponCode: (couponType === "single") ? response.codes[0].code.replace("C-", "") : "",
                        nbRedemptionSingle: (couponType === "single") ? String(response.codes[0].allowed_uses) : "",
                        nbRedemptionMultiple: (couponType === "multiple") ? String(response.codes.length) : "",
                        couponStartDate: startDate,
                        couponStartTime: startTime,
                        couponEndDate: expiresDate,
                        couponEndTime: expiresTime,
                        couponDescription: response.desc
                    }

                    let couponCodes = response.codes.map(c => {
                        return {
                            id: c.id,
                            code: c.code,
                            status: "",
                            nbRedemption: c.allowed_uses,
                            usedCount: c.used_count,
                            customer: (c.customer) ? c.customer : [],
                            transactionId: (c.transaction_id) ? c.transaction_id : ""
                        }
                    });

                    let selectedEvents = response.event_date_ids;

                    this.setState({ 
                        activeCoupon,
                        couponDetails: activeCoupon,
                        couponCodes,
                        selectedEvents,
                        isReadyToSelectCodes: true,
                        validation,
                        isSecondStepOpen:true
                    });

                    this.validateAllRequiredFields();
                } else {
                    this.setMessage(window.general_strings.msg.oops, activeCouponInfoResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function activeCouponInfo() {
            return await ApiRequest(`/coupons/${couponId}`, {
                method: 'GET'
            });
        }
    }

    selectAllCouponCheckboxes = (e) => {
        let value = e.target.value;
        (e.target.checked) ? value = true : value = false;
        const table = document.getElementById('couponCodesTbl');
        const inputs = table.querySelectorAll('input');
        inputs.forEach((input) => {
            input.checked = value;
        });
        
        this.updateSelectedCoupon();
    }

    updateSelectedCoupon = () => {
        const table = document.getElementById('couponCodesTbl');
        const inputs = table.querySelectorAll('input');
        let selectedCodes = [];

        inputs.forEach((input) => {
            if(input.checked && input.id !== "input-coupon-all") {
                selectedCodes.push(parseInt(input.id.replace("input-coupon-", ""), 10));
            }
        });
        
        let isReadyToSelectCodes = selectedCodes.length > 0;
        this.setState({ 
            selectedCodes,
            isReadyToSelectCodes
        });
    }

    downloadCoupons = () => {
        let id = this.state.activeCoupon.id;
        let couponCodes = this.state.selectedCodes;
        let query = "";
        for (var i = 0; i < couponCodes.length; i++) {
            let prefix = (i === 0) ? "?" : "&";
            query += prefix + "code_ids[]=" + couponCodes[i];
        }

        (async () => {
            try {
                const couponCsvFileResponse = await couponCsvFile();
                console.log('events list response: ', couponCsvFileResponse);

                if(!couponCsvFileResponse.data.error){
                    this.setMessage('','','');

                    const csvString = couponCsvFileResponse.data;
                    var a = window.document.createElement('a');
                    a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(csvString));
                    a.setAttribute('download', 'coupon_codes.csv');
                    a.click();
                } else {
                    this.setMessage(window.general_strings.msg.oops, couponCsvFileResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function couponCsvFile() {
            return await ApiRequest(`/coupons/${id}/csv${query}`, {
                method: 'GET'
            });
        }
    }

    detectDymoPrinter = async () => {
        try {
            let dymo = new Dymo();
            const responsePrinters = await dymo.getPrinters();
            console.log('Get Dymo Printers: ', responsePrinters);
            if (responsePrinters) {
                let printers = responsePrinters || [];
                console.log(printers);
                this.setState({
                    printers,
                    currentPrinter: printers[0]
                })
            }
        } catch (error) {
            console.log(error, 'Dymo Printer', 'Trying alternative method...');
            try {
                let dymo = new Dymo({ hostname: '127.0.0.1' });
                const responsePrinters = await dymo.getPrinters();
                console.log('Get Dymo Printers: ', responsePrinters);
                if (responsePrinters) {
                    let printers = responsePrinters || [];
                    console.log(printers);
                    this.setState({
                        printers,
                        currentPrinter: printers[0]
                    })
                }
            } catch (error) {
                console.log(error, 'Dymo Printer', 'Failure.');
            }
        }
    }

    handlePrinterChange = (e) => {
        let value = e.target.value;
        let currentPrinter = { ...this.state.currentPrinter };
        currentPrinter = value;
        this.setState({ currentPrinter });
    }

    toggleAlertModal = (e) => {
        e.preventDefault();
        this.setState({
            isModalOpen: !this.state.isModalOpen,
        });
    }

    confirmAlertModal = () => {
        this.setState({
            isModalOpen: false
        }, () => this.printCoupon());
    }

    printerSelect = () => {
        return (
            <div className="showtix-form__group">
                <div className="showtix-form__select">
                    {this.state.printers.length > 0 ?
                        <select className="showtix-input"
                            value={this.state.currentPrinter}
                            onChange={this.handlePrinterChange}>
                            <PrinterOptions printers={this.state.printers} />
                        </select> :
                        <h2>{strings.noPrinterAvailable}</h2>
                    }
                </div>
            </div>
        )
    }

    printCoupon = () => {
        const selectedToPrint = [];
        this.state.selectedCodes.forEach(selectedCode => {
            this.state.couponCodes.forEach(code => {
                if (selectedCode === code.id) {
                    selectedToPrint.push(code);
                }
            })
        });
        selectedToPrint.forEach(code => {
            code.couponName = this.state.activeCoupon.couponName;
            code.couponDescription = this.state.activeCoupon.couponDescription;
            DymoPrint(this.state.currentPrinter, 'coupon', code);
        });
    }

    detectBocaPrinter = () => {
        let currentPrinterBoca = localStorage.getItem('defaultBocaPrinter') ? localStorage.getItem('defaultBocaPrinter') : '';
        this.setState({
            currentPrinterBoca,
        });
        try {
            let boca = new Boca();
            boca.getJSPrintManager();
            boca.getBocaPrinters().then((responsePrinters) => {
                console.log("responsePrinters", responsePrinters);
                if (responsePrinters) {
                    console.log("has boca printer");
                    let bocaPrinters = responsePrinters.filter((printer) => printer.name.toLowerCase().includes('boca'));
                    let starPrintersUSB = responsePrinters.filter((printer) => printer.name.toLowerCase().includes('star'));
                    this.setState({
                        printersBoca: bocaPrinters,
                        printersStarUSB: starPrintersUSB,
                    });
                }
            },(error) => {
                console.log("no boca printer");
            });
        } catch (error) {
            console.log(error, 'Boca Printer', 'Failure.');
        }
    };

    handlePrinterChangeBoca = (e) => {
        let value = e.target.value;
        let currentPrinterBoca = { ...this.state.currentPrinterBoca };
        currentPrinterBoca = value;
        this.setState({ currentPrinterBoca });
        localStorage.setItem('defaultBocaPrinter', currentPrinterBoca);
    }

    printerSelectBoca = () => {
        return (
            <div className="showtix-form__group">
                <div className="showtix-form__select">
                    {this.state.printersBoca.length > 0 ?
                        <select className="showtix-input"
                                value={this.state.currentPrinterBoca}
                                onChange={this.handlePrinterChangeBoca}>
                            <option>Select</option>
                            {this.state.printersBoca.map((printer, i) => (
                                <option value={this.state.printersBoca[i].name}>{this.state.printersBoca[i].name}</option>
                            ))}
                        </select> :
                        <h2>{strings.noPrinterAvailable}</h2>
                    }
                </div>
            </div>
        )
    };

    toggleAlertModalBoca = (e) => {
        e.preventDefault();
        console.log('this.state.currentPrinterBoca', this.state.currentPrinterBoca)
        if (this.state.currentPrinterBoca === '') {
            this.setState({
                isModalOpenBoca: !this.state.isModalOpenBoca,
            });
        } else {
            this.printCouponBoca();
        }
    }

    confirmAlertModalBoca = () => {
        if(!localStorage.getItem("defaultBocaPrinter")) {
            localStorage.setItem('defaultBocaPrinter', localStorage.getItem("printersBoca")[0]);
            this.setState({
                currentPrinterBoca: localStorage.getItem("printersBoca")[0]
            });
        }
        this.setState({
            isModalOpenBoca: false
        }, () => this.printCouponBoca());
    }

    printCouponBoca = () => {
        const selectedToPrint = [];
        this.state.selectedCodes.forEach(selectedCode => {
            this.state.couponCodes.forEach(code => {
                if (selectedCode === code.id) {
                    selectedToPrint.push(code);
                }
            })
        });
        selectedToPrint.forEach(code => {
            code.couponName = this.state.activeCoupon.couponName;
            code.couponDescription = this.state.activeCoupon.couponDescription;
        });
        let boca = new Boca();
        boca.printFGL(this.state.currentPrinterBoca, 'coupon', selectedToPrint);
    }

    detectStarPrinter = async () => {
        let currentPrinterStar = localStorage.getItem('defaultStarPrinter') ? localStorage.getItem('defaultStarPrinter') : '';
        this.setState({
            currentPrinterStar,
        });
        let printersStar = this.state.printersStar;
        //let printersStarUSB = this.state.printersStarUSB;
        try {
            /* let star = new Star();
            star.getStarPrinters2().then((responsePrinters) => {
                console.log('responsePrinters', responsePrinters)
                if (responsePrinters) {
                    printersStarUSB = responsePrinters;
                    this.setState({
                        printersStarUSB,
                    });
                }
            }, (error) => {
                console.log("no boca printer");
            }); */

            const getPrintersResponse = await getStarPrinters();
            console.log('getPrintersResponse', getPrintersResponse);
            if (getPrintersResponse.data.printers) {
                console.log('PRINTER STAR', getPrintersResponse.data.printers)
                printersStar = getPrintersResponse.data.printers;
                this.setState({
                    printersStar,
                });
            }
        } catch (error) {
            console.log(error);
        }

        async function getStarPrinters() {
            return await ApiRequest(`/printers`, {
                method: 'GET',
            });
        }
    };

    handlePrinterChangeStar = (e) => {
        let value = e.target.value;
        let currentPrinterStar = { ...this.state.currentPrinterStar };
        currentPrinterStar = value;
        this.setState({ currentPrinterStar });
        localStorage.setItem('defaultStarPrinter', currentPrinterStar);
    };

    toggleAlertModalStar = (e) => {
        e.preventDefault();
        if (this.state.currentPrinterStar === '') {
            console.log('toggleAlertModalStar');
            this.setState({
                isModalOpenStar: !this.state.isModalOpenStar,
            });
        } else {
            console.log('printTransactionStarTickets');
            this.printCouponStar();
        }
    }

    confirmAlertModalStar = () => {
        if(!localStorage.getItem("defaultStarPrinter")) {
            localStorage.setItem('defaultStarPrinter', localStorage.getItem("printersStar")[0]);
            this.setState({
                currentPrinterStar: localStorage.getItem("printersStar")[0]
            });
        }
        this.setState({
            isModalOpenStar: false
        }, () => this.printCouponStar());
    }

    printCouponStar = () => {
        const client = this.state.client;
        const selectedToPrint = [];
        this.state.selectedCodes.forEach(selectedCode => {
            this.state.couponCodes.forEach(code => {
                if (selectedCode === code.id) {
                    selectedToPrint.push(code);
                }
            })
        });
        selectedToPrint.forEach(code => {
            code.couponName = this.state.activeCoupon.couponName;
            code.couponDescription = this.state.activeCoupon.couponDescription;
        });
        let star = new Star();
        let isStarUSB = !localStorage.getItem('defaultStarPrinter').includes('http');
        console.log('isStarUSB', isStarUSB)
        if (isStarUSB) {
            star.printFGLUSB(localStorage.getItem('defaultStarPrinter'), 'coupon', selectedToPrint, client);
        } else {
            star.printFGL('coupon', selectedToPrint, client);
        }
    };

    printerSelectStar = () => {
        return (
            <React.Fragment>
                <div className="showtix-form__group">
                    <div className="showtix-form__select">
                        {this.state.printersStar.length > 0 ? (
                                <select className="showtix-input"
                                    value={this.state.currentPrinterStar}
                                    onChange={this.handlePrinterChangeStar}
                                >
                                    <option>Select</option>
                                    {this.state.printersStar.map((printer, i) => (
                                        <option value={this.state.printersStar[i].ip_address}>{this.state.printersStar[i].name} ({this.state.printersStar[i].ip_address})</option>
                                    ))}
                                    <option value='http://localhost:8001'>SM-S230i</option>
                                </select>
                            ) : (
                                <select className="showtix-input"
                                    value={this.state.currentPrinterStar}
                                    onChange={this.handlePrinterChangeStar}
                                >
                                    <option>Select</option>
                                    <option value='http://localhost:8001'>SM-S230i</option>
                                </select>
                            )
                        }
                    </div>
                </div>
                {this.state.printersStarUSB.length > 0 && (
                    <React.Fragment>
                        USB Printers:
                        <div className="showtix-form__group">
                            <div className="showtix-form__select">
                                {this.state.printersStarUSB.length > 0 && (
                                    <select className="showtix-input"
                                        value={this.props.currentPrinterStar}
                                        onChange={this.props.handlePrinterChangeStar}
                                    >
                                        <option>Select</option>
                                        {this.state.printersStarUSB.map((printer, i) => (
                                            <option value={this.state.printersStarUSB[i].name}>{this.state.printersStarUSB[i].name}</option>
                                        ))}
                                    </select>
                                )}
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        )
    };

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    render() { 
        return ( 
            <div>
                <AlertModal
                    isModalOpen={this.state.isModalOpen}
                    toggleAlertModal={this.toggleAlertModal}
                    confirmAlertModal={this.confirmAlertModal}
                    modalTitle={strings.modalTitle}
                    modalDescription={this.printerSelect()}
                    disabled={this.state.printers.length < 1}
                />
                <AlertModalBoca
                    isModalOpenBoca={this.state.isModalOpenBoca}
                    toggleAlertModalBoca={this.toggleAlertModalBoca}
                    confirmAlertModalBoca={this.confirmAlertModalBoca}
                    modalTitle={strings.modalTitle}
                    modalDescription={this.printerSelectBoca()}
                    disabled={this.state.printersBoca.length < 1}
                />
                <AlertModalStar
                    isModalOpenStar={this.state.isModalOpenStar}
                    toggleAlertModalStar={this.toggleAlertModalStar}
                    confirmAlertModalStar={this.confirmAlertModalStar}
                    modalDescription={this.printerSelectStar()}
                    printersStar={this.state.printersStar}
                />
                <CouponForm 
                    isSecondStepOpen={this.state.isSecondStepOpen}
                    couponDetails={this.state.couponDetails}
                    validation={this.state.validation}
                    isReadyToSubmit={this.state.isReadyToSubmit}
                    couponExists={this.state.couponExists}
                    setCouponType={this.setCouponType}
                    handleChange={this.handleChange}
                    validateRequiredField={this.validateRequiredField}
                    message={this.state.message}
                />
                <CouponEvents 
                    isSecondStepOpen={this.state.isSecondStepOpen}
                    events={this.state.events}
                    selectedEvents={this.state.selectedEvents}
                    selectAllEventCheckboxes={this.selectAllEventCheckboxes}
                    updateSelectedEvents={this.updateSelectedEvents}
                    isReadyToSubmit={this.state.isReadyToSubmit}
                    couponExists={this.state.couponExists}
                    saveCoupon={this.saveCoupon}
                />
                {this.state.couponExists &&
                <CouponReview 
                    ref="review"
                    isSecondStepOpen={this.state.isSecondStepOpen}
                    couponDetails={this.state.couponDetails}
                    couponCodes={this.state.couponCodes}
                    isReadyToSelectCodes={this.state.isReadyToSelectCodes}
                    selectedCodes={this.state.selectedCodes}
                    downloadCoupons={this.downloadCoupons}
                    toggleAlertModal={this.toggleAlertModal}
                    printers={this.state.printers}
                    printCoupon={this.printCoupon}
                    updateSelectedCoupon={this.updateSelectedCoupon}
                    selectAllCouponCheckboxes={this.selectAllCouponCheckboxes}
                    printersBoca={this.state.printersBoca}
                    printCouponBoca={this.printCouponBoca}
                    currentPrinterBoca={this.state.currentPrinterBoca}
                    toggleAlertModalBoca={this.toggleAlertModalBoca}
                    printersStar={this.state.printersStar}
                    printCouponStar={this.printCouponStar}
                    currentPrinterStar={this.state.currentPrinterStar}
                    toggleAlertModalStar={this.toggleAlertModalStar}
                />
                }
            </div>    
        )
    }
}

CreateCoupon.propTypes = {
    
}
 
export default CreateCoupon;


// WEBPACK FOOTER //
// ./src/components/CreateCoupon/CreateCoupon.js